export const Z_INDEX_PORTAL = 99
export const Z_INDEX_NAV = 10
export const Z_INDEX_TOOLTIP = 100
/** Product-tour overlay (dims the page). Must sit above sticky page toppers. */
export const Z_INDEX_TOUR_OVERLAY = 1400
/** Product-tour card and elevated anchor. Above the tour overlay. */
export const Z_INDEX_TOUR_CARD = 1401
